import React from 'react';

import Button from '@material-ui/core/Button';
import clsx from 'clsx';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import PropTypes from 'prop-types';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import { Typography } from '@material-ui/core';

import ArrowBack from 'components/common/components/ArrowBack';
import RequiredField from 'components/common/components/RequiredField';
import SendEmail from 'components/user/admin/users/SendEmail';
import UserPermission from 'components/user/admin/users/EditUser/EditUserRender/PermissionEdit/PermissionEdit';

import ButtonsUseStyles from 'consts/styles/Buttons';
import { formStyles } from 'consts/styles/Form';
import { userStyles } from 'consts/styles/User';

const ComponentUserRender = props => {
  const {
    add,
    getSelectedOrganizationName,
    isGroupChecked,
    values,
    handleChange,
    onGroupChange,
    subtitles,
    organizations,
    showErrors,
    user,
    userGroups,
    groupArray,
    goBackToMainScreen,
    subtitlesErrors,
    userPermissionNames,
  } = props;

  const formClasses = formStyles();
  const classesUser = userStyles();
  const classesButtons = ButtonsUseStyles();

  const error = groupArray.length === 0;

  return (
    <Container
      component="main"
      maxWidth="md"
      className={`${classesUser.User}__wrapper__content__container`}
    >
      <div className={`${formClasses.Form}__overflow-component`}>
        <div
          className={`${formClasses.Form}--flex ${formClasses.Form}--flex--center ${formClasses.Form}__text-field`}
        >
          <ArrowBack clickFunction={goBackToMainScreen} fromLeft={10} />
          <Typography
            variant="h3"
            className={`${formClasses.Form}__text-field__title`}
          >
            {subtitles.header_}
          </Typography>
        </div>
        <form
          className={`${formClasses.Form}__overflow-component ${formClasses.Form}__overflow-component--small`}
          noValidate
        >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <label
                className={clsx(`${formClasses.Form}__label`, {
                  [`${formClasses.Form}__text-field__form-helper--error`]:
                    !values.firstName.length && showErrors,
                })}
                htmlFor="firstName"
              >
                {subtitles.formFields.firstName_}*
              </label>
              <TextField
                autoComplete="firstName"
                error={!values.firstName.length && showErrors}
                name="firstName"
                variant="outlined"
                required
                fullWidth
                id="firstName"
                onChange={handleChange}
                value={values.firstName}
                size="small"
                InputProps={{
                  classes: {
                    input: `${formClasses.Form}__text-field`,
                    focused: `${formClasses.Form}__text-field--focused`,
                  },
                }}
                helperText={
                  showErrors && !values.firstName.length
                    ? subtitlesErrors.required
                    : ''
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <label
                className={clsx(`${formClasses.Form}__label`, {
                  [`${formClasses.Form}__text-field__form-helper--error`]:
                    !values.lastName.length && showErrors,
                })}
                htmlFor="lastName"
              >
                {subtitles.formFields.lastName_}*
              </label>
              <TextField
                variant="outlined"
                required
                error={!values.lastName.length && showErrors}
                fullWidth
                id="lastName"
                name="lastName"
                autoComplete="lastName"
                onChange={handleChange}
                value={values.lastName}
                size="small"
                InputProps={{
                  classes: {
                    input: `${formClasses.Form}__text-field`,
                    focused: `${formClasses.Form}__text-field--focused`,
                  },
                }}
                helperText={
                  showErrors && !values.lastName.length
                    ? subtitlesErrors.required
                    : ''
                }
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <label
                className={clsx(`${formClasses.Form}__label`, {
                  [`${formClasses.Form}__text-field__form-helper--error`]:
                    !values.username.length && showErrors,
                })}
                htmlFor="username"
              >
                {subtitles.formFields.username_}*
              </label>
              <TextField
                autoComplete="username"
                error={!values.username.length && showErrors}
                name="username"
                variant="outlined"
                required
                fullWidth
                id="username"
                onChange={handleChange}
                value={values.username}
                size="small"
                InputProps={{
                  classes: {
                    input: `${formClasses.Form}__text-field`,
                    focused: `${formClasses.Form}__text-field--focused`,
                  },
                }}
                helperText={
                  !values.username.length && showErrors
                    ? `${subtitlesErrors.required}. ${subtitlesErrors.onlyNumbersAndLetters_}`
                    : ''
                }
              />
            </Grid>
            {user ? null : (
              <>
                <Grid item xs={12} sm={6}>
                  <label
                    className={clsx(`${formClasses.Form}__label`, {
                      [`${formClasses.Form}__text-field__form-helper--error`]:
                        !values.password.length && showErrors,
                    })}
                    htmlFor="password"
                  >
                    {subtitles.formFields.password_}*
                  </label>
                  <TextField
                    variant="outlined"
                    required
                    error={!values.password.length && showErrors}
                    fullWidth
                    id="password"
                    name="password"
                    autoComplete="password"
                    type="password"
                    onChange={handleChange}
                    value={values.password}
                    size="small"
                    InputProps={{
                      classes: {
                        input: `${formClasses.Form}__text-field`,
                        focused: `${formClasses.Form}__text-field--focused`,
                      },
                    }}
                    helperText={
                      showErrors && !values.password
                        ? `${subtitlesErrors.required} ${subtitlesErrors.passwordRequirements_}`
                        : ''
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <label
                    className={clsx(`${formClasses.Form}__label`, {
                      [`${formClasses.Form}__text-field__form-helper--error`]:
                        !values.rePassword.length && showErrors,
                    })}
                    htmlFor="rePassword"
                  >
                    {subtitles.formFields.rePassword_}*
                  </label>
                  <TextField
                    variant="outlined"
                    required
                    error={!values.rePassword.length && showErrors}
                    fullWidth
                    id="rePassword"
                    name="rePassword"
                    // autoComplete="repeat"
                    type="password"
                    onChange={handleChange}
                    value={values.rePassword}
                    size="small"
                    InputProps={{
                      classes: {
                        input: `${formClasses.Form}__text-field`,
                        focused: `${formClasses.Form}__text-field--focused`,
                      },
                    }}
                    helperText={
                      showErrors && !values.rePassword
                        ? `${subtitlesErrors.required} ${subtitlesErrors.passwordRequirements_}`
                        : ''
                    }
                  />
                </Grid>
              </>
            )}
            <Grid item xs={12} sm={6}>
              <label
                className={clsx(`${formClasses.Form}__label`, {
                  [`${formClasses.Form}__text-field__form-helper--error`]:
                    !values.phone.length && showErrors,
                })}
                htmlFor="phone"
              >
                {subtitles.formFields.phone_}*
              </label>
              <TextField
                variant="outlined"
                required
                error={!values.phone.length && showErrors}
                fullWidth
                id="phone"
                name="phone"
                autoComplete="phone"
                onChange={handleChange}
                value={values.phone}
                size="small"
                InputProps={{
                  classes: {
                    input: `${formClasses.Form}__text-field`,
                    focused: `${formClasses.Form}__text-field--focused`,
                  },
                }}
                helperText={
                  showErrors && !values.phone.length
                    ? `${subtitlesErrors.required}. ${subtitlesErrors.phoneRequirements_}`
                    : ''
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <label
                className={clsx(`${formClasses.Form}__label`, {
                  [`${formClasses.Form}__text-field__form-helper--error`]:
                    !values.email.length && showErrors,
                })}
                htmlFor="email"
              >
                {subtitles.formFields.email_}*
              </label>
              <TextField
                autoComplete="email"
                name="email"
                error={!values.email.length && showErrors}
                variant="outlined"
                required
                fullWidth
                id="email"
                type="email"
                onChange={handleChange}
                value={values.email}
                size="small"
                InputProps={{
                  classes: {
                    input: `${formClasses.Form}__text-field`,
                    focused: `${formClasses.Form}__text-field--focused`,
                  },
                }}
                helperText={
                  showErrors && !values.email.length
                    ? subtitlesErrors.required
                    : ''
                }
              />
            </Grid>

            <Grid item xs={12} sm={5}>
              <label className={`${formClasses.Form}__label`} htmlFor="city">
                {subtitles.formFields.city_}
              </label>
              <TextField
                autoComplete="city"
                name="city"
                error={!values.city.length && showErrors}
                variant="outlined"
                fullWidth
                id="city"
                onChange={handleChange}
                value={values.city}
                size="small"
                InputProps={{
                  classes: {
                    input: `${formClasses.Form}__text-field`,
                    focused: `${formClasses.Form}__text-field--focused`,
                  },
                }}
                helperText={
                  showErrors && !values.city.length
                    ? `${subtitlesErrors.required}`
                    : ''
                }
              />
            </Grid>
            <Grid item xs={12} sm={5}>
              <label className={`${formClasses.Form}__label`} htmlFor="street">
                {subtitles.formFields.street_}
              </label>
              <TextField
                variant="outlined"
                fullWidth
                id="street"
                name="street"
                error={!values.street.length && showErrors}
                autoComplete="street"
                onChange={handleChange}
                value={values.street}
                size="small"
                InputProps={{
                  classes: {
                    input: `${formClasses.Form}__text-field`,
                    focused: `${formClasses.Form}__text-field--focused`,
                  },
                }}
                helperText={
                  showErrors && !values.street.length
                    ? `${subtitlesErrors.required}`
                    : ''
                }
              />
            </Grid>
            <Grid item xs={4} sm={2}>
              <label className={`${formClasses.Form}__label`} htmlFor="number">
                {subtitles.formFields.number_}
              </label>
              <TextField
                variant="outlined"
                fullWidth
                id="number"
                name="number"
                error={!values.number && showErrors}
                autoComplete="number"
                onChange={handleChange}
                value={values.number}
                size="small"
                InputProps={{
                  classes: {
                    input: `${formClasses.Form}__text-field`,
                    focused: `${formClasses.Form}__text-field--focused`,
                  },
                }}
                helperText={
                  showErrors && !values.number
                    ? `${subtitlesErrors.required}`
                    : ''
                }
              />
            </Grid>
            {user ? <UserPermission user={user} /> : null}
            <Grid item xs={3} sm={12}>
              <Typography className={`${formClasses.Form}__text-field`}>
                {subtitles.formFields.userGroups_}
              </Typography>
              <FormControl
                required
                error={error}
                component="fieldset"
                className={`${formClasses.Form}--flex ${formClasses.Form}--flex--center`}
              >
                <FormGroup row className={`${formClasses.Form}__text-field`}>
                  {userGroups.map((group, index) => (
                    <FormControlLabel
                      key={index}
                      control={
                        <Checkbox
                          checked={isGroupChecked(group.id)}
                          onChange={onGroupChange}
                          value={group.id}
                          size="small"
                          // style={{ transform: 'scale(0.7)' }}
                          classes={{
                            root: `${formClasses.Form}__text-field--focused`,
                            checked: `${formClasses.Form}__text-field--focused`,
                          }}
                        />
                      }
                      label={userPermissionNames[`${group.name}_`]}
                    />
                  ))}
                </FormGroup>
                <FormHelperText
                  className={`${formClasses.Form}__text-field ${
                    error
                      ? `${formClasses.Form}__text-field__form-helper--error`
                      : `${formClasses.Form}__text-field__form-helper`
                  }`}
                >
                  {subtitles.formFields.checkBoxGroupInfo_}*
                </FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={4} sm={6}>
              <p
                className={`${formClasses.Form}__text-field  ${
                  !values.organization.length && showErrors
                    ? `${formClasses.Form}__text-field__form-helper--error`
                    : `${formClasses.Form}__text-field__form-helper`
                }`}
                id="organization-label"
              >
                {subtitles.formFields.organization_}
              </p>
              <Select
                labelId="organization-label"
                id="organization"
                error={!values.organization.length && showErrors}
                name="organization"
                MenuProps={{
                  className: `${formClasses.Form}__select__menu`,
                  anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                  },
                  MenuListProps: {
                    className: `${formClasses.Form}__select__menu__item`,
                  },
                  getContentAnchorEl: null,
                  classes: {
                    list: `${formClasses.Form}__select__menu--background-color`,
                  },
                }}
                className={`${formClasses.Form}__select`}
                classes={{
                  root: `${formClasses.Form}__text-field`,
                  icon: `${formClasses.Form}__text-field`,
                }}
                value={getSelectedOrganizationName()}
                onChange={handleChange}
              >
                {organizations.map((organization, index) => (
                  <MenuItem key={index} value={organization.uid}>
                    {organization.name}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          </Grid>
          <Button
            type="button"
            fullWidth
            onClick={add}
            className={`${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsRectangle}`}
          >
            {subtitles.button_}
          </Button>
        </form>
      </div>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <RequiredField />
        </Grid>
        {user ? (
          <Grid item>
            <SendEmail emailValue={values.email} />
          </Grid>
        ) : null}
      </Grid>
    </Container>
  );
};

ComponentUserRender.propTypes = {
  add: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  subtitles: PropTypes.object.isRequired,
  organizations: PropTypes.array.isRequired,
  handleChange: PropTypes.func.isRequired,
  onGroupChange: PropTypes.func.isRequired,
  getSelectedOrganizationName: PropTypes.func.isRequired,
  isGroupChecked: PropTypes.func.isRequired,
  showErrors: PropTypes.bool.isRequired,
  user: PropTypes.object,
  userGroups: PropTypes.array.isRequired,
  groupArray: PropTypes.array.isRequired,
  goBackToMainScreen: PropTypes.func.isRequired,
  subtitlesErrors: PropTypes.object.isRequired,
  userPermissionNames: PropTypes.object.isRequired,
};

export default ComponentUserRender;
